

import general from './general';

export default new Vuex.Store({
  modules: {
    general
  },
  plugins: [window.createPersistedState({
    paths: ['general'],
    storage: window.localStorage,
  })],
});


// WEBPACK FOOTER //
// ./assets/js/modules/store/store.js